import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const SkeletonCard = styled.div`
  width: 357px;
  height: 566px;
  background: ${COLORS.white};
  padding: 28px 24px 26px 24px;
  div {
    height: 100%;
  }

  @media ${device.laptop} {
    width: 424px;
  }
`;

export const SkeletonWrapper = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  height: 100%;
  /* gap: 12px; */
  .image {
    height: 168px;
    width: 100%;
  }
  .vehicleName {
    margin-top: 16px;
    height: 36px;
    width: 100%;
  }
  .vehicleTrim {
    margin-top: 12px;
    height: 48px;
    width: 100%;
  }

  @media ${device.laptop} {
    .image {
      width: 300px;
      height: 224px;
    }
  }
`;

export const SkeletonDealerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  height: 100%;
  width: 180px;
  .dealerAddress {
    height: 48px;
    width: 100%;
  }
  .dealerPhone {
    height: 24px;
    width: 100%;
  }
`;

export const SkeletonLoad = styled(Skeleton)``;
